import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const RERARegistrationIndia = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />
      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        RERA Registration
      </div>
      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        RERA (Real Estate Regulatory Authority) registration, governed by the
        Real Estate (Regulation & Development) Act, is a mandatory process to
        regulate real estate activities, ensuring transparency and
        accountability across India’s states.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Legislative Framework */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Legislative Framework
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
                marginBottom: isMobile ? "5px" : "10px",
              }}
            ></div>
          </div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The RERA Act, implemented at the state level, mandates registration
            before advertising, marketing, booking, selling, or inviting
            investment in plots, apartments, or buildings, aiming to enhance
            transparency, minimize fraud, and protect promoter and purchaser
            interests.
          </p>

          {/* Regulatory Responsibilities */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Regulatory Responsibilities
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            State-level RERA authorities oversee registration approvals for
            commercial and residential properties, regulate sale and purchase
            transactions, and ensure compliance with the Act’s provisions.
          </p>

          {/* Applicability Scope */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Applicability Scope
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            RERA applies to promoters, projects, and real estate agents involved
            in commercial, residential, or plotted developments. It is mandatory
            for builders developing land over 500 square meters or proposing more
            than eight apartments, as well as agents facilitating property
            transactions.
          </p>

          {/* Document Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Document Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Required documents vary by entity:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Promoter:</strong> ID and address proof, photographs, PAN
              number, email ID, commencement certificate with sanction plan,
              layout plan, project location details, action plan, parking slot
              availability, legal title deeds, and previous project details (name,
              status, delays).
            </li>
            <li>
              <strong>Promoter as Company:</strong> Certificate of Incorporation,
              CIN/TAN number, Memorandum and Articles of Association, audited
              balance sheets, director’s reports for three years, and
              director/chairperson details.
            </li>
            <li>
              <strong>Real Estate Agent:</strong> ID and address proof,
              photographs, company particulars (name, address, byelaws, MOA,
              AOA, company type).
            </li>
          </ul>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The online process varies by state, filed via the official website
            (e.g., http://rera.[state].gov.in). Promoters/agents submit
            applications with documents and fees (via demand draft, banker’s
            cheque, or online payment), with the authority deciding within 30
            days—silence implies acceptance.
          </p>
          <ol
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              Fill the state-specific RERA registration form with required
              details and documents.
            </li>
            <li>Submit documents and pay fees through approved methods.</li>
            <li>
              Await acceptance or rejection within 30 days; no response deems the
              application accepted.
            </li>
            <li>
              Receive the registration certificate and number upon approval.
            </li>
          </ol>

          {/* Certificate Validity */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Certificate Validity
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The RERA registration certificate is valid statewide for the duration
            of the project or until revoked, issued within 30 days of application
            approval.
          </p>

          {/* Penalty Provisions */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Penalty Provisions
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Agents face a Rs. 10,000 daily penalty (up to 5% of the
            plot/building cost) for defaults, with imprisonment up to one year
            for unfair trade practices under the RERA Act.
          </p>

          {/* Exempt Project Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Exempt Project Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Projects exempt from RERA registration include those on land under
            500 square meters or with fewer than eight apartments,
            renovation/repair/redevelopment without marketing, and completed
            projects with a certificate before RERA’s commencement.
          </p>

          {/* Revocation Conditions */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Revocation Conditions
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registration may be revoked for non-compliance, breach of approval
            terms, unfair practices, or fraud, following a 30-day notice and show
            cause opportunity, with the authority deciding based on the
            promoter’s response.
          </p>

          {/* Grievance Mechanism */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Grievance Mechanism
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            RERA authorities directly handle buyer complaints, ensuring prompt
            resolution and maintaining oversight over registered projects and
            agents.
          </p>

          {/* Project Disclosure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Project Disclosure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registration requires detailed disclosure of project plans and
            activities, ensuring buyers receive comprehensive information about
            the development process.
          </p>

          {/* Concluding Overview */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Overview
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            RERA registration establishes a structured regulatory framework for
            India’s real estate sector, requiring compliance with state-specific
            processes, documentation, and ongoing oversight to uphold industry
            standards.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RERARegistrationIndia;